import React, { useState } from "react";
import { CustomButton } from "../../../../../../common/components";
import styles from "./FeatureRow.module.css";
import { translate } from "../../../../../../common/providers";
import AgentSidePanel from "../../../dsi-form-studio/components/agent-panel/AgentSidePanel";
import { isNonEmptyArray } from "../../../../../../common/utils";
import { useApi } from "../../../../../../common/hooks";
import { AiFeatureService } from "../../../../../../api";

export default function FeatureRow({ feature, onRefresh }) {
	const { featureId, featureName, featureDescription, featurePlaceHolders, agentId, agentName } = feature || {};
	const [openAgentSidePanel, setOpenAgentSidePanel] = useState(false);
	const { call: updateFeatureAgent } = useApi(AiFeatureService.updateFeatureAgent);
	const handleChangeAgent = (tempAgent) => {
		updateFeatureAgent(
			{ featureId, agentId: tempAgent?.id || agentId },
			{ add: (tempAgent && tempAgent?.id !== agentId) || false }
		)
			.then(() => {
				if (onRefresh && typeof onRefresh === "function") {
					onRefresh();
				}
				setOpenAgentSidePanel(false);
			})
			.catch(console.error);
	};
	const handleOpenDialogAgentSelection = () => {
		setOpenAgentSidePanel((prev) => !prev);
	};
	return (
		<>
			<div key={featureId} className={styles.row}>
				<div>
					<span>{featureName}</span>
				</div>
				<div>
					<span className={styles.criteriaType}>{featureDescription}</span>
				</div>
				<div>
					<span className={styles.limitedText}>
						{(isNonEmptyArray(featurePlaceHolders) &&
							featurePlaceHolders.map((placeholder) => placeholder).join(", ")) ||
							"-"}
					</span>
				</div>
				<div>
					<CustomButton
						variant={(agentId && "outlined") || "contained"}
						onClick={handleOpenDialogAgentSelection}
					>
						{(agentId && agentName) || translate("dsi.form-studio.criteria.select-agent.button")}
					</CustomButton>
				</div>
			</div>
			<AgentSidePanel
				agent={{ agentId, agentTitle: agentName }}
				open={openAgentSidePanel}
				onClose={handleOpenDialogAgentSelection}
				onSubmit={handleChangeAgent}
			/>
		</>
	);
}
